function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { matchesBrand, matchesCategory, matchesStrain, matchesVendor, matchesProductId, matchesInventoryTag, matchesProductTag } from 'shared/order/bogo/common';
import { isArmageddonDiscountSyncSpecial, isSpecialVersion3dot5 } from 'shared/helpers/specials-3-5';
export var prepareExcludedProducts = function() {
    var excluded = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ruleKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], productsHash = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _ruleKeys_products;
    var result = {
        _id: excluded._id,
        excludedProducts: {},
        selectedExcludedProducts: {}
    };
    if ((excluded === null || excluded === void 0 ? void 0 : excluded.products) && (ruleKeys === null || ruleKeys === void 0 ? void 0 : (_ruleKeys_products = ruleKeys.products) === null || _ruleKeys_products === void 0 ? void 0 : _ruleKeys_products.length) > 0) {
        // handle sale specials
        var saleExclusions = setupExcludedProducts(excluded.products, ruleKeys.products, productsHash);
        result.excludedProducts = _object_spread({}, (saleExclusions === null || saleExclusions === void 0 ? void 0 : saleExclusions.excludedProducts) || {});
        result.selectedExcludedProducts = _object_spread({}, (saleExclusions === null || saleExclusions === void 0 ? void 0 : saleExclusions.selectedExcludedProducts) || {});
    } else {
        var _ruleKeys_conditions, _ruleKeys_rewards;
        // handle offers
        if ((ruleKeys === null || ruleKeys === void 0 ? void 0 : (_ruleKeys_conditions = ruleKeys.conditions) === null || _ruleKeys_conditions === void 0 ? void 0 : _ruleKeys_conditions.length) > 0) {
            var conditionExclusions = setupExcludedProducts(excluded.conditions, ruleKeys.conditions, productsHash);
            result.excludedProducts.conditions = _object_spread({}, (conditionExclusions === null || conditionExclusions === void 0 ? void 0 : conditionExclusions.excludedProducts) || {});
            result.selectedExcludedProducts.conditions = _object_spread({}, (conditionExclusions === null || conditionExclusions === void 0 ? void 0 : conditionExclusions.selectedExcludedProducts) || {});
        }
        if ((ruleKeys === null || ruleKeys === void 0 ? void 0 : (_ruleKeys_rewards = ruleKeys.rewards) === null || _ruleKeys_rewards === void 0 ? void 0 : _ruleKeys_rewards.length) > 0) {
            var rewardExclusions = setupExcludedProducts(excluded.rewards, ruleKeys.rewards, productsHash);
            result.excludedProducts.rewards = _object_spread({}, (rewardExclusions === null || rewardExclusions === void 0 ? void 0 : rewardExclusions.excludedProducts) || {});
            result.selectedExcludedProducts.rewards = _object_spread({}, (rewardExclusions === null || rewardExclusions === void 0 ? void 0 : rewardExclusions.selectedExcludedProducts) || {});
        }
    }
    return result;
};
export var getConditionName = function(param) {
    var brandId = param.brandId, brandName = param.brandName, categoryName = param.categoryName, productGroup = param.productGroup;
    if (productGroup === 'categories') {
        return categoryName;
    }
    if (productGroup === 'brands') {
        return "BRAND__".concat(brandId !== null && brandId !== void 0 ? brandId : '*', "__").concat(brandName !== null && brandName !== void 0 ? brandName : '*');
    }
    return null;
};
var getExcludedBrandData = function(ruleKeys) {
    var brands = {};
    _.forEach(ruleKeys, function(rule) {
        var brandId;
        var brandName;
        var split = _.split(rule, '__');
        split.shift(); // remove our BRAND_
        brandId = split.shift(); // get our id
        brandName = split.join(); // get our brandName
        // get rid of any junk
        if (brandId === '*') {
            brandId = null;
        }
        if (brandName === '*') {
            brandName = null;
        }
        if (brandId || brandName) {
            brands[brandId !== null && brandId !== void 0 ? brandId : brandName] = brandName;
        }
    });
    return brands;
};
var isBrandExclusionMatch = function(product) {
    var rule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return matchesBrand(rule, product, rule.productGroup, true);
};
var isCategoryExclusionMatch = function(product) {
    var rule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return matchesCategory(rule, product, rule.productGroup, true);
};
var isStrainExclusionMatch = function(product) {
    var rule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return matchesStrain(rule, product, true);
};
var isVendorExclusionMatch = function(product) {
    var rule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return matchesVendor(rule, product, true);
};
var isActiveBatchTagExclusionMatch = function(product) {
    var rule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return matchesInventoryTag(rule, product, true);
};
var isProductTagExclusionMatch = function(product) {
    var rule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return matchesProductTag(rule, product, true);
};
var isProductExclusionMatch = function(product) {
    var exclusion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _id = product._id, id = product.id, enterpriseProductId = product.enterpriseProductId;
    var exclusionId = exclusion._id, productIds = exclusion.productIds;
    var productId = _id !== null && _id !== void 0 ? _id : id;
    var epid = "EPID_".concat(enterpriseProductId);
    var productIdMatch = _.includes(_.compact([
        epid,
        enterpriseProductId,
        productId
    ]), exclusionId);
    var productIdsMatch = _.includes(productIds, productId); // v3.5
    return productIdMatch || productIdsMatch || matchesProductId(exclusion, product, true);
};
export var isExcludedProduct = function(product) {
    var exclusions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], special = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var checkAllExclusions = isSpecialVersion3dot5(special) || isArmageddonDiscountSyncSpecial(special);
    var isExcluded = false;
    _.forEach(exclusions, function(exclusion) {
        if (isProductExclusionMatch(product, exclusion)) {
            isExcluded = true;
            return false;
        }
        if (checkAllExclusions) {
            if (isBrandExclusionMatch(product, exclusion)) {
                isExcluded = true;
                return false;
            }
            if (isCategoryExclusionMatch(product, exclusion)) {
                isExcluded = true;
                return false;
            }
            if (isStrainExclusionMatch(product, exclusion)) {
                isExcluded = true;
                return false;
            }
            if (isVendorExclusionMatch(product, exclusion)) {
                isExcluded = true;
                return false;
            }
            if (isActiveBatchTagExclusionMatch(product, exclusion)) {
                isExcluded = true;
                return false;
            }
            if (isProductTagExclusionMatch(product, exclusion)) {
                isExcluded = true;
                return false;
            }
        }
        return true; // Consistent return
    });
    return isExcluded;
};
var setupExcludedProducts = function() {
    var excluded = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], ruleKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], productsHash = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result = {
        excludedProducts: {},
        selectedExcludedProducts: {}
    };
    var isBrand = !!_.find(ruleKeys, function(rule) {
        return _.includes(rule, 'BRAND_');
    });
    var brands = isBrand && getExcludedBrandData(ruleKeys);
    _.forEach(excluded, function(item) {
        var itemKey = item === null || item === void 0 ? void 0 : item.key;
        var uncategorizedKey = _.includes(itemKey, 'uncategorized_') ? "Uncategorized ".concat(_.split(itemKey, 'uncategorized_')[1]) : itemKey;
        if (!itemKey) {
            return;
        }
        // confirm that this is still an active rule
        var isActiveKey = _.includes(ruleKeys, itemKey) || _.includes(ruleKeys, uncategorizedKey);
        // brands are inconsistent and might be indexed by either id or name
        if (isBrand) {
            var __find, __find1;
            var matchesOnBrandName = (__find = _.find(_.toPairs(brands), function(param) {
                var _param = _sliced_to_array(param, 2), _id = _param[0], name = _param[1];
                return name === itemKey;
            })) === null || __find === void 0 ? void 0 : __find[1];
            var matchesOnBrandId = (__find1 = _.find(_.toPairs(brands), function(param) {
                var _param = _sliced_to_array(param, 1), id = _param[0];
                return id === itemKey;
            })) === null || __find1 === void 0 ? void 0 : __find1[0];
            // don't accept the brandName in lieu of the id
            matchesOnBrandId = matchesOnBrandId === matchesOnBrandName ? null : matchesOnBrandId;
            if (matchesOnBrandId) {
                itemKey = matchesOnBrandId;
                isActiveKey = true;
            }
            if (matchesOnBrandName) {
                itemKey = matchesOnBrandName;
                isActiveKey = true;
            }
        }
        if (isActiveKey) {
            var _result_excludedProducts, _result_selectedExcludedProducts;
            if (!((_result_excludedProducts = result.excludedProducts) === null || _result_excludedProducts === void 0 ? void 0 : _result_excludedProducts[itemKey])) {
                result.excludedProducts[itemKey] = [];
            }
            if (!((_result_selectedExcludedProducts = result.selectedExcludedProducts) === null || _result_selectedExcludedProducts === void 0 ? void 0 : _result_selectedExcludedProducts[itemKey])) {
                result.selectedExcludedProducts[itemKey] = {};
            }
            // confirm that this product is still available
            var isActiveProduct = !!(productsHash === null || productsHash === void 0 ? void 0 : productsHash[item._id]);
            if (isActiveProduct) {
                // update main exclusions list
                result.excludedProducts[itemKey].push({
                    __key: item._id,
                    Name: item.Name
                });
                // ensure that this is a selected exclusion
                result.selectedExcludedProducts[itemKey][item._id] = true;
            }
        }
    });
    return result;
};
export default {
    getConditionName: getConditionName,
    isExcludedProduct: isExcludedProduct,
    prepareExcludedProducts: prepareExcludedProducts
};
